import {
  Image as ChakraImage,
  type ImageProps as ChakraImageProps,
} from '@chakra-ui/react';
import type { FC } from 'react';

type Props = Omit<ChakraImageProps, 'rounded'> & {
  rounded?: boolean;
  circle?: boolean;
};

export const Image: FC<Props> = ({
  rounded,
  circle,
  borderRadius,
  ...rest
}) => (
  <ChakraImage
    maxWidth="100%"
    verticalAlign="middle"
    borderRadius={
      borderRadius ?? (rounded ? '3px' : circle ? '50%' : undefined)
    }
    {...rest}
  />
);
